/* ============================================================
   Onde foi comprado

   Pergunta que aparece ao marcar "Comprei", opcional. Separa comer no
   local, retirar e pedir por app — e qual app. Pensado para o futuro:
   quanto do que o grupo come vem de delivery, e de qual plataforma, é
   dado que só existe aqui, e só vale se for AGREGADO e anônimo (é o que
   a política de privacidade permite vender, desde set/2026).

   A lista existe duas vezes: aqui e em `canalValido()` da regra do
   Firestore, que não importa nada. Mudou uma, muda a outra.
   ============================================================ */

export const CANAIS = [
  { id: "local", rotulo: "No local", emoji: "🍽️" },
  { id: "retirada", rotulo: "Retirada", emoji: "🛍️" },
  { id: "delivery", rotulo: "Delivery", emoji: "🛵" },
] as const;

export type Canal = (typeof CANAIS)[number]["id"];

/** Os apps de entrega. "outro" cobre o resto sem virar campo livre. */
export const APPS_DE_DELIVERY = [
  { id: "ifood", rotulo: "iFood" },
  { id: "99food", rotulo: "99Food" },
  { id: "keeta", rotulo: "Keeta" },
  { id: "rappi", rotulo: "Rappi" },
  { id: "aiqfome", rotulo: "Aiqfome" },
  { id: "proprio", rotulo: "Do restaurante" },
  { id: "outro", rotulo: "Outro" },
] as const;

export type AppDeDelivery = (typeof APPS_DE_DELIVERY)[number]["id"];

export const canalValido = (v: unknown): Canal | null =>
  CANAIS.some((c) => c.id === v) ? (v as Canal) : null;

export const appValido = (v: unknown): AppDeDelivery | null =>
  APPS_DE_DELIVERY.some((a) => a.id === v) ? (v as AppDeDelivery) : null;
